$(function () {
	if ($.cookie('cookie_message_closed') == 'yes') {
	    // Do nothing
		$(".cookies-popup").hide(); // Show the cookie popup
	}
	else {
		$(".cookies-popup").show(); // Show the cookie popup
		$(".cookies-popup").addClass("active");
	}

    $(".close-cookie-message").click(function () {
	    $(".cookies-popup").removeClass("active");
	    $.cookie('cookie_message_closed', 'yes', { expires: 365, path: '/' });
    });
});
